export default "__VITE_ASSET__Zx7ja5Ug__"